export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M21.5,6.156H5.5a.934.934,0,0,0-.932.933V17.582a.934.934,0,0,0,.932.933h5.667v1.829H7.147a.25.25,0,1,0,0,.5H19.853a.25.25,0,0,0,0-.5h-4.02V18.515H21.5a.934.934,0,0,0,.932-.933V7.089A.934.934,0,0,0,21.5,6.156ZM15.333,20.344H11.667V18.515h3.666Zm6.6-2.762a.433.433,0,0,1-.432.433H5.5a.433.433,0,0,1-.432-.433V7.089A.433.433,0,0,1,5.5,6.656h16a.433.433,0,0,1,.432.433Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,8.1a4.236,4.236,0,1,0,4.236,4.236A4.241,4.241,0,0,0,13.5,8.1Zm0,7.972a3.736,3.736,0,1,1,3.736-3.736A3.74,3.74,0,0,1,13.5,16.071Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.75,12.217V9.767a.25.25,0,0,0-.5,0v2.568a.249.249,0,0,0,.092.194l1.431,1.165a.254.254,0,0,0,.158.056.25.25,0,0,0,.158-.444Z"
		/>
	</svg>
)
